import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminCollectionsNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('collection');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
